export const getProperSuccessClass = (containerName) => {
  let components = ["LandingContainer", "FooterContainer", "IntextBlue", "Ressort", "PreviewBlue"]



  containerName = containerName === undefined ? null : containerName.split('-')[0]

  if ( components.includes(containerName) ) {
    return 'color-confirm2'
  }
  return 'success'
}
